// Shared money/date formatting for the Deposits tab — mirrors TransactionTable.jsx's
// own local CURRENCY_SYMBOLS/formatAmount/formatDate, factored out here since three
// new deposit components (list, detail, wizard) all need the identical formatting.
export const CURRENCY_SYMBOLS = { USD: '$', EUR: '€', GBP: '£', JPY: '¥', AUD: 'A$' };

export const formatAmount = (amount, currency) =>
  `${CURRENCY_SYMBOLS[currency] ?? (currency ? `${currency} ` : '')}${Number(amount ?? 0).toFixed(2)}`;

export const formatDate = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })
    : '—';

export const formatDateTime = (dateString) =>
  dateString
    ? new Date(dateString).toLocaleString('en-US', {
        month: 'short', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true,
      })
    : '—';
